import React from "react";
import {
  confidenceOpensReview,
  getStatusBadgeClass,
  getStatusLabel,
  hasPriceDiff,
} from "../../utils/invoiceDisplayUtils";

export function InvoiceStatusBadge({ status }) {
  return (
    <span className={`inline-flex px-2 py-0.5 text-xs font-medium rounded ${getStatusBadgeClass(status)}`}>
      {getStatusLabel(status)}
    </span>
  );
}

export function InvoiceConfidenceCell({ invoice, onOpenReview }) {
  if (hasPriceDiff(invoice)) {
    return (
      <button
        type="button"
        onClick={() => onOpenReview?.(invoice)}
        className="inline-flex px-1.5 py-0.5 text-xs font-medium rounded bg-red-100 text-red-800 hover:bg-red-200"
        title="Open review — price mismatch"
      >
        Price diff
      </button>
    );
  }
  if (invoice?.needsReview) {
    return (
      <button
        type="button"
        onClick={() => onOpenReview?.(invoice)}
        className="inline-flex px-1.5 py-0.5 text-xs font-medium rounded bg-amber-100 text-amber-800 hover:bg-amber-200"
        title="Open review"
      >
        Review
      </button>
    );
  }
  if (invoice?.confidence != null) {
    return (
      <span className="text-xs text-gray-500">{(invoice.confidence * 100).toFixed(0)}%</span>
    );
  }
  return <span className="text-xs text-gray-400">—</span>;
}

export function invoiceNeedsReviewAttention(invoice) {
  return confidenceOpensReview(invoice);
}
